import { Api } from '@monorepo/shared/apiClient';
import { MutationConfig, useMutation } from 'react-query';

type UseViewCopyToAllProjectsParams = {
  config?: MutationConfig<Api.CopyViewToAllProjectsResponse, Api.ErrorResponse>;
};

export const useViewCopyToAllProjects = (
  params?: UseViewCopyToAllProjectsParams,
) =>
  useMutation(Api.copyViewToAllProjects, {
    ...params?.config,
    onSuccess: async (res, mutationFuncParams) => {
      // Not invalidating any cache since this operation is asynchronous,
      // and nothing is created at the time we get server response

      await params?.config?.onSuccess?.(res, mutationFuncParams);
    },
  });
